export interface IProfileState {
}

export function initialProfileState(): IProfileState {
    return {};
}
